import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import Empty from '../../utils/Empty';
import VendingMetPayments from './VendingMetPayments';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
// =========================================================================
// CSS del nuevo layout del carrito — scoped bajo .vmc-root
// =========================================================================
const VMC_CSS = `
.vmc-root * { box-sizing: border-box; }

.vmc-root {
  --brand: #006AFF;
  --brand-hover: #0052CC;
  --green: #0EA35B;
  --red: #E11D2E;
  --bg-0: #F7F7F4;
  --bg-1: #FFFFFF;
  --ink-0: #0B0B0F;
  --ink-1: #3A3A42;
  --ink-2: #8A8A94;
  --line: rgba(11,11,15,0.08);
  --shadow-sm: 0 1px 2px rgba(11,11,15,0.04), 0 2px 8px rgba(11,11,15,0.05);
  --shadow-md: 0 8px 24px -8px rgba(11,11,15,0.14), 0 2px 6px rgba(11,11,15,0.06);
  --shadow-lg: 0 28px 70px -20px rgba(0,106,255,0.28), 0 10px 24px -10px rgba(11,11,15,0.14);

  --sp-xs: clamp(4px, 0.6vmin, 8px);
  --sp-sm: clamp(6px, 1vmin, 12px);
  --sp-md: clamp(10px, 1.6vmin, 20px);
  --sp-lg: clamp(14px, 2.4vmin, 32px);
  --sp-xl: clamp(18px, 3.2vmin, 44px);

  font-family: 'Geist', system-ui, sans-serif;
  color: var(--ink-0);
  background:
    radial-gradient(1400px 800px at 90% -10%, rgba(0,106,255,0.09), transparent 55%),
    radial-gradient(1100px 700px at -10% 110%, rgba(14,163,91,0.06), transparent 55%),
    var(--bg-0);
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.vmc-root::before {
  content: "";
  position: absolute; inset: 0;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>");
  pointer-events: none;
  opacity: 0.5;
  z-index: 0;
  mix-blend-mode: multiply;
}
.vmc-root > * { position: relative; z-index: 1; }

/* ===== HEADER FIJO ===== */
.vmc-header {
  background: rgba(255,255,255,0.78);
  backdrop-filter: saturate(1.2) blur(10px);
  -webkit-backdrop-filter: saturate(1.2) blur(10px);
  border-bottom: 1px solid var(--line);
  padding: var(--sp-md) var(--sp-lg);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--sp-md);
}
.vmc-header-back {
  width: clamp(48px, 5.6vmin, 72px);
  height: clamp(48px, 5.6vmin, 72px);
  display: grid; place-items: center;
  background: var(--bg-1);
  border: 1px solid var(--line);
  border-radius: clamp(12px, 1.5vmin, 18px);
  color: var(--ink-0);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
  padding: 0;
}
.vmc-header-back:hover { transform: translateY(-1px); box-shadow: var(--shadow-md); background: var(--ink-0); color: #fff; }
.vmc-header-back:active { transform: scale(0.95); }
.vmc-header-back i { font-size: clamp(20px, 2.6vmin, 28px); line-height: 1; }

.vmc-header-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 0;
}
.vmc-header-title h2 {

  font-size: clamp(22px, 3vmin, 42px);
  line-height: 1;
  letter-spacing: -0.015em;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: clamp(8px, 1.2vmin, 14px);
  color: var(--ink-0);
}
.vmc-header-title h2 i {
  font-style: normal;
  font-size: 0.85em;
  color: var(--brand);
}
.vmc-header-title .vmc-header-sub {
  font-size: clamp(9px, 1vmin, 12px);
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-2);
  font-weight: 500;
}

.vmc-header-count {
  min-width: clamp(44px, 5vmin, 64px);
  height: clamp(44px, 5.2vmin, 64px);
  padding: 0 clamp(12px, 1.6vmin, 20px);
  display: inline-flex; align-items: center; justify-content: center;
  gap: clamp(5px, .8vmin, 8px);
  background: linear-gradient(180deg, #2E86FF 0%, #006AFF 100%);
  color: #fff;
  border: none;
  border-radius: 999px;
  box-shadow: 0 8px 20px -4px rgba(0,106,255,0.45), inset 0 1px 0 rgba(255,255,255,0.25);
  font-size: clamp(14px, 1.8vmin, 20px);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.vmc-header-count i { font-size: 1em; }

/* ===== BODY (lista de items) ===== */
.vmc-body {
  min-height: 0; min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: var(--sp-lg) var(--sp-lg) var(--sp-md);
  display: flex;
  flex-direction: column;
  gap: var(--sp-md);
  scrollbar-width: thin;
  scrollbar-color: var(--ink-2) transparent;
}
.vmc-body::-webkit-scrollbar { width: 6px; }
.vmc-body::-webkit-scrollbar-thumb { background: var(--ink-2); border-radius: 3px; opacity: 0.4; }
.vmc-body::-webkit-scrollbar-track { background: transparent; }

.vmc-empty {
  flex: 1;
  display: grid;
  place-items: center;
  padding: var(--sp-xl);
  text-align: center;
  color: var(--ink-2);
}

/* ===== CART ITEM ===== */
.vmc-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: clamp(12px, 1.8vmin, 20px);
  padding: clamp(10px, 1.4vmin, 16px);
  background: var(--bg-1);
  border: 1px solid var(--line);
  border-radius: clamp(14px, 1.8vmin, 20px);
  box-shadow: var(--shadow-sm);
  transition: transform .25s cubic-bezier(.2,.9,.2,1), box-shadow .25s ease;
  animation: vmc-rise .4s cubic-bezier(.2,.9,.2,1) both;
}
.vmc-item:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); }

@keyframes vmc-rise {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

.vmc-item-media {
  width: clamp(64px, 9vmin, 100px);
  height: clamp(64px, 9vmin, 100px);
  border-radius: clamp(10px, 1.4vmin, 16px);
  overflow: hidden;
  background: linear-gradient(180deg, #f5f5f0, #eceae3);
  flex-shrink: 0;
  box-shadow: 0 4px 12px -4px rgba(11,11,15,0.15);
}
.vmc-item-media img {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
}

.vmc-item-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vmin, 12px);
}
.vmc-item-name {
  font-size: clamp(14px, 1.7vmin, 18px);
  font-weight: 600;
  color: var(--ink-0);
  line-height: 1.2;
  letter-spacing: -0.005em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.vmc-item-controls {
  display: flex;
  align-items: center;
  gap: clamp(10px, 1.4vmin, 16px);
  flex-wrap: wrap;
}

.vmc-amount-group {
  display: inline-flex;
  align-items: center;
  gap: clamp(6px, 1vmin, 10px);
  background: var(--bg-0);
  border-radius: 999px;
  padding: clamp(3px, .5vmin, 5px);
}
.vmc-amount-btn {
  width: clamp(30px, 3.8vmin, 40px);
  height: clamp(30px, 3.8vmin, 40px);
  border-radius: 50%;
  border: none;
  background: var(--bg-1);
  color: var(--ink-0);
  font-size: clamp(16px, 2vmin, 22px);
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: transform .15s ease, background .2s ease, color .2s ease;
  display: grid; place-items: center;
  padding: 0;
  line-height: 1;
}
.vmc-amount-btn:hover { background: var(--brand); color: #fff; transform: scale(1.08); }
.vmc-amount-btn:active { transform: scale(0.92); }
.vmc-amount-count {
  min-width: clamp(20px, 2.6vmin, 28px);
  text-align: center;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  font-size: clamp(13px, 1.6vmin, 16px);
  color: var(--ink-0);
  margin: 0;
  padding: 0 clamp(2px, .4vmin, 6px);
}

.vmc-item-price {

  font-size: clamp(18px, 2.4vmin, 26px);
  line-height: 1;
  color: var(--green);
  font-variant-numeric: tabular-nums;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  white-space: nowrap;
}
.vmc-item-price small {
  font-size: 0.55em;
  color: var(--green);
  margin-right: 2px;
  vertical-align: 0.35em;
  font-family: 'Geist', sans-serif;
  font-weight: 500;
  font-style: normal;
}

.vmc-item-trash {
  width: clamp(40px, 4.6vmin, 52px);
  height: clamp(40px, 4.6vmin, 52px);
  border-radius: 50%;
  border: 1px solid var(--line);
  background: var(--bg-1);
  color: var(--red);
  cursor: pointer;
  display: grid; place-items: center;
  transition: transform .18s ease, background .2s ease, color .2s ease;
  flex-shrink: 0;
  padding: 0;
}
.vmc-item-trash:hover { background: var(--red); color: #fff; transform: scale(1.08); }
.vmc-item-trash:active { transform: scale(0.92); }
.vmc-item-trash i { font-size: clamp(16px, 2vmin, 22px); line-height: 1; }

/* ===== FOOTER FIJO (totales + acciones) ===== */
.vmc-footer {
  background: rgba(255,255,255,0.88);
  backdrop-filter: saturate(1.2) blur(10px);
  -webkit-backdrop-filter: saturate(1.2) blur(10px);
  border-top: 1px solid var(--line);
  box-shadow: 0 -8px 24px -8px rgba(11,11,15,0.06);
  padding: var(--sp-md) var(--sp-lg) calc(var(--sp-md) + env(safe-area-inset-bottom, 0));
  display: grid;
  gap: var(--sp-md);
}

.vmc-add-more {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: clamp(6px, 1vmin, 10px);
  background: var(--bg-1);
  color: var(--brand);
  border: 1.5px dashed rgba(0,106,255,0.4);
  border-radius: 999px;
  padding: clamp(10px, 1.4vmin, 16px);
  font-size: clamp(13px, 1.5vmin, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: transform .18s ease, background .2s ease, border-color .2s ease;
  font-family: inherit;
}
.vmc-add-more:hover {
  background: rgba(0,106,255,0.06);
  border-color: var(--brand);
  transform: translateY(-1px);
}
.vmc-add-more:active { transform: translateY(0) scale(0.99); }
.vmc-add-more i { font-size: 1.1em; }

/* Totales en tarjeta */
.vmc-totals {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--sp-md);
  align-items: stretch;
}

.vmc-totals-box {
  background: var(--bg-1);
  border: 1px solid var(--line);
  border-radius: clamp(14px, 1.8vmin, 20px);
  padding: clamp(12px, 1.8vmin, 20px);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: clamp(4px, .7vmin, 8px);
}
.vmc-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: clamp(12px, 1.4vmin, 15px);
  color: var(--ink-1);
  font-variant-numeric: tabular-nums;
}
.vmc-total-row p { margin: 0; }
.vmc-total-row.is-grand {
  padding-top: clamp(6px, .9vmin, 10px);
  margin-top: clamp(2px, .4vmin, 5px);
  border-top: 1px solid var(--line);
  font-size: clamp(14px, 1.8vmin, 20px);
  color: var(--ink-0);
  font-weight: 600;
}
.vmc-total-row.is-grand .vmc-total-price {

  font-size: clamp(20px, 2.8vmin, 32px);
  color: var(--green);
  font-style: normal;
  line-height: 1;
}
.vmc-total-row.is-grand .vmc-total-price small {
  font-size: 0.55em;
  margin-right: 2px;
  vertical-align: 0.35em;
  font-family: 'Geist', sans-serif;
  font-weight: 500;
  font-style: normal;
}
.vmc-total-price { font-weight: 600; color: var(--ink-0); }

/* Acciones laterales */
.vmc-actions {
  display: flex;
  flex-direction: column;
  gap: var(--sp-sm);
  min-width: clamp(160px, 22vmin, 260px);
}
.vmc-btn-cancel,
.vmc-btn-pay {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: clamp(6px, 1vmin, 10px);
  padding: clamp(12px, 1.7vmin, 20px) clamp(16px, 2.2vmin, 26px);
  border: none;
  border-radius: 999px;
  font-size: clamp(13px, 1.6vmin, 18px);
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
  font-family: inherit;
  white-space: nowrap;
}
.vmc-btn-cancel {
  background: var(--bg-1);
  color: var(--red);
  border: 1px solid rgba(225,29,46,0.25);
}
.vmc-btn-cancel:hover { background: var(--red); color: #fff; transform: translateY(-1px); border-color: var(--red); }
.vmc-btn-cancel:active { transform: translateY(0) scale(0.98); }

.vmc-btn-pay {
  background: linear-gradient(180deg, #2E86FF 0%, #006AFF 100%);
  color: #fff;
  box-shadow: 0 10px 24px -6px rgba(0,106,255,0.5), inset 0 1px 0 rgba(255,255,255,0.25);
  flex: 1;
}
.vmc-btn-pay:hover { transform: translateY(-2px); filter: brightness(1.06); }
.vmc-btn-pay:active { transform: translateY(0) scale(0.98); }
.vmc-btn-pay i { font-size: 1.15em; }

/* ===== Responsive ===== */
@media (max-width: 640px) {
  .vmc-totals { grid-template-columns: 1fr; }
  .vmc-actions { flex-direction: row; min-width: 0; }
  .vmc-btn-cancel, .vmc-btn-pay { flex: 1; }

  .vmc-item { grid-template-columns: auto 1fr; grid-template-rows: auto auto; }
  .vmc-item-trash { grid-column: 2; justify-self: end; }
  .vmc-item-controls { width: 100%; justify-content: space-between; }
}

@media (max-width: 400px) {
  .vmc-header-title .vmc-header-sub { display: none; }
  .vmc-header { padding: var(--sp-sm) var(--sp-md); }
  .vmc-body { padding: var(--sp-md); }
  .vmc-footer { padding: var(--sp-sm) var(--sp-md); }
  .vmc-actions { flex-direction: column; }
}

@media (orientation: landscape) and (max-height: 520px) {
  .vmc-header { padding: var(--sp-sm) var(--sp-md); }
  .vmc-header-title h2 { font-size: clamp(16px, 2.4vmin, 24px); }
  .vmc-header-title .vmc-header-sub { display: none; }
  .vmc-body { padding: var(--sp-sm) var(--sp-md); gap: var(--sp-sm); }
  .vmc-footer { padding: var(--sp-sm) var(--sp-md); gap: var(--sp-sm); }
  .vmc-totals-box { padding: var(--sp-sm) var(--sp-md); }
  .vmc-add-more { padding: clamp(6px, 1vmin, 10px); }
}

@media (prefers-reduced-motion: reduce) {
  .vmc-item, .vmc-header-back, .vmc-amount-btn, .vmc-item-trash,
  .vmc-btn-cancel, .vmc-btn-pay, .vmc-add-more {
    animation: none !important;
    transition: none !important;
  }
}

/* Override del Modal de react-bootstrap para fullscreen sin paddings */
.vmc-bootstrap-override .modal-content {
  border-radius: 0;
  border: none;
  background: transparent;
}
.vmc-bootstrap-override .modal-body {
  padding: 0 !important;
  height: 100vh;
  height: 100dvh;
}
`;


// =========================================================================
// COMPONENTE PRINCIPAL — toda la lógica original preservada
// =========================================================================
function VendingModalCart({ setShoppingCart, shoppingCart, showModalShopingCart, setShowModalShopingCart, eventHandler, dataClient, setDataClient, showModalPayment, setShowModalPayment, setEventHandlerMenu, setStatusScreen, statusComunicationVending, groups, orderNumber, setOrderNumber, payments, setPayments, oledScreenPayments, getTemp, setAtivityTimer }) {

  let machine = JSON.parse(localStorage.getItem('machine_vending'));

  //Totals states
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [invoiceTotalItbms, setInvoiceTotalItbms] = useState(0);
  const [invoiceSubtotal, setInvoiceSubtotal] = useState(0);
  const [invoiceTotalDiscount, setInvoiceTotalDiscount] = useState(0);
  const [taxesArrayAll, setTaxesArrayAll] = useState([])
  //Event handler shopping cart
  const [eventHandlerShoppingCart, setEventHandlerShoppingCart] = useState(0);
  const [eventHandlerAll, setEventHandlerAll] = useState(0);

  //decimal reduction
  const decimalReduction = (value) => {

    let string = value.toString()
    let arrayString = string.split(".");
    let newDecimalString = []
    let sample = ''
    if (arrayString[1] != undefined) {
      newDecimalString = arrayString[1].slice(0, 2);
      sample = arrayString[0] + "." + newDecimalString
      console.log("Hice la reduccion");
    } else {
      console.log("Array: " + arrayString);
      console.log("Decimal: " + newDecimalString);
      console.log("Nuevo valor: " + sample);
      sample = string;
    }

    let endValue = parseFloat(sample)
    return endValue
  }

  //Function to calculate the invoice totals 
  const calculateInvoiceTotals = (products) => {
    //For every new calculate we set the totals 
    let invoiceTotalDiscount = 0
    let invoiceSubtotal = 0
    let invoiceTotalItbms = 0
    let invoiceTotal = 0
    let taxesArray = [];
    //if we dont we products we put the totals in 0 for default 
    if (products.length === 0) {
      //We calculate the totals of the invoice 
      setInvoiceTotalDiscount(0)
      setInvoiceSubtotal(0);
      setInvoiceTotalItbms(0)
      setInvoiceTotal(0);
      setTaxesArrayAll(taxesArray);
    } else {
      //For every product we calculate 
      for (let i = 0; i < products.length; i++) {
        let product_info = products[i]

        //Variables
        let total_product_price = 0;
        let total_product_itbms = 0;
        let product_total_discount = 0;
        //We set the total discount of the product
        product_total_discount = (product_info.unit_discount * product_info.amount);
        //We set the total of the product 
        total_product_price = (product_info.amount * (product_info.price - product_info.unit_discount));

        //Calculate tax by group--------------------------------
        let taxesGroup = product_info.taxes;
        taxesGroup.forEach(tax => {

          //calculate tax  value and add it to array

          let valueTax = decimalReduction((product_info.amount * ((product_info.price - product_info.unit_discount) * tax.taxtValue)));
          tax.total = valueTax;
          //Identifier tax of the group position
          var index = taxesArray.findIndex(function (info, i) {
            return info.tax_id === tax.tax_id
          });

          if (index < 0) {
            let taxInfoNow = {
              "dTasaITBMSValue": tax.dTasaITBMSValue,
              "percentage": tax.percentage,
              "tax": tax.tax,
              "tax_id": tax.tax_id,
              "taxtValue": tax.taxtValue,
              "total": valueTax
            }
            taxesArray.push(taxInfoNow);
          } else {
            taxesArray[index].total = (taxesArray[index].total + valueTax)
          }

          total_product_itbms = (total_product_itbms + valueTax);
        });
        //-------------------------------------------------------


        //We set the itbms of the product 
        //total_product_itbms = (product_info.amount * ((product_info.price - product_info.unit_discount) * product_info.taxtValue));

        //We calculate the totals of the invoice 
        invoiceTotalDiscount = invoiceTotalDiscount + product_total_discount;
        invoiceSubtotal = decimalReduction((invoiceSubtotal + total_product_price));
        invoiceTotalItbms = invoiceTotalItbms + total_product_itbms;
        invoiceTotal = invoiceTotal + total_product_price + total_product_itbms;

        console.log("invoiceTotalDiscount:" + invoiceTotalDiscount);
        console.log("invoiceSubtotal:" + invoiceSubtotal);
        console.log("invoiceTotalItbms:" + invoiceTotalItbms);
        console.log("invoiceTotal:" + invoiceTotal);
      }

      //We set the totals
      setInvoiceTotalDiscount(invoiceTotalDiscount)
      setInvoiceSubtotal(invoiceSubtotal);
      setInvoiceTotalItbms(invoiceTotalItbms);
      setInvoiceTotal(invoiceTotal);
      setTaxesArrayAll(taxesArray);
    }



  }

  //Function to incremet the product amount on the shopping cart 
  const decrementProductAmount = (product_index) => {
    //We search the product on the list 
    let product = shoppingCart[product_index];
    //We affect the product data 
    product.amount = product.amount - 1;
    product.cantidadItem = product.amount

    //We check if the product amount is lower than 0
    if (product.amount <= 0) {
      //if is lower or equal to 0 we delete the product of the shopping cart list 
      shoppingCart.splice(product_index, 1);
      setShoppingCart([...shoppingCart])
    }
    //We set the handler to recharge the data
    setEventHandlerShoppingCart(1);
  };

  //Function to incremet the product amount on the shopping cart 
  const incrementProductAmount = (product_index) => {
    //We search the product on the list 
    let product = shoppingCart[product_index];
    //We affect the product data 
    product.amount = product.amount + 1;
    product.cantidadItem = product.amount
    //We set the handler to recharge the data
    setEventHandlerShoppingCart(1);

  };


  //Function to clear the shopping cart
  const clearShoppingCart = () => {
    //We set the shopping cart to empty
    setShoppingCart([]);
    //We close the modal
    setShowModalShopingCart(false)
    //We set the handler to recharge the data
    setEventHandlerShoppingCart(1);
  };


  //Hook to calculate the totals of the invoice when a product is changed on the shopping cart
  useEffect(() => {
    calculateInvoiceTotals(shoppingCart);
  }, [shoppingCart]);

  //Hook to calculate the totals of the invoice if some product is deleted or incremented on the shopping cart 
  useEffect(() => {
    calculateInvoiceTotals(shoppingCart);
  }, [eventHandler]);

  //Hook to recharge the component
  useEffect(() => {
    calculateInvoiceTotals(shoppingCart);
    setEventHandlerShoppingCart(0);
  }, [eventHandlerShoppingCart]);

  // Inyectar CSS del carrito una sola vez
  useEffect(() => {
    const id = "vmc-root-styles";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = VMC_CSS;
    document.head.appendChild(style);
  }, []);

  return (
    <>

      <Modal
         show={showModalShopingCart}
        // show={true}
        fullscreen
        onHide={() => setShowModalShopingCart(false)}
        dialogClassName="vmc-bootstrap-override"
        contentClassName="vmc-bootstrap-override"
      >
        <Modal.Body>
          <div className="vmc-root">

            {/* ========== HEADER FIJO ========== */}
            <header className="vmc-header">
              <button
                className="vmc-header-back"
                onClick={() => { setShowModalShopingCart(false) }}
                aria-label="Volver"
                title="Volver al menú"
              >
                <i className="uil uil-arrow-left"></i>
              </button>
              <div className="vmc-header-title">
                <h2>
                  <i className="uil uil-shopping-cart"></i>
                  Tu carrito
                </h2>
                <span className="vmc-header-sub">Revisa tu pedido</span>
              </div>
              <div className="vmc-header-count" aria-label="Cantidad de productos">
                <i className="uil uil-apps"></i>
                <span>{shoppingCart.length}</span>
              </div>
            </header>

            {/* ========== BODY (lista items) ========== */}
            <div className="vmc-body">
              {!shoppingCart.length ? (
                <div className="vmc-empty">
                  <Empty title="Vacío" msg="No se ha añadido ningún producto al carrito" img='' />
                </div>
              ) : (
                shoppingCart.map((product, index) => (
                  <div className="vmc-item" key={index}>
                    <div className="vmc-item-media">
                      <img src={buildCloudinaryImageUrl({url: product.img, width: 300, type: "image", quality: "auto"})} alt={product.name} loading="lazy" />
                    </div>
                    <div className="vmc-item-info">
                      <div className="vmc-item-name" title={product.name}>{product.name}</div>
                      <div className="vmc-item-controls">
                        <div className="vmc-amount-group">
                          <button
                            className="vmc-amount-btn"
                            onClick={e => decrementProductAmount(index)}
                            aria-label="Disminuir"
                          >−</button>
                          <p className="vmc-amount-count">{product.amount}</p>
                          <button
                            className="vmc-amount-btn"
                            onClick={e => incrementProductAmount(index)}
                            aria-label="Aumentar"
                          >+</button>
                        </div>
                        <div className="vmc-item-price">
                          <small>$</small>{product.price.toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <button
                      className="vmc-item-trash"
                      title="Borrar Producto"
                      onClick={() => {
                        // Mantiene la lógica: si se decrementa hasta 0, el item se elimina automáticamente
                        let p = shoppingCart[index];
                        p.amount = 0;
                        p.cantidadItem = 0;
                        shoppingCart.splice(index, 1);
                        setShoppingCart([...shoppingCart]);
                        setEventHandlerShoppingCart(1);
                      }}
                      aria-label="Borrar producto"
                    >
                      <i className="uil uil-trash-alt"></i>
                    </button>
                  </div>
                ))
              )}
            </div>

            {/* ========== FOOTER FIJO ========== */}
            <footer className="vmc-footer">
              <button
                className="vmc-add-more"
                onClick={() => { setShowModalShopingCart(false) }}
              >
                <i className="uil uil-plus"></i>
                Agregar más productos
              </button>

              <div className="vmc-totals">
                <div className="vmc-totals-box">
                  {invoiceTotalDiscount > 0 && (
                    <div className="vmc-total-row">
                      <p>Descuento</p>
                      <p className="vmc-total-price">$ {invoiceTotalDiscount.toFixed(2)}</p>
                    </div>
                  )}
                  <div className="vmc-total-row">
                    <p>Subtotal</p>
                    <p className="vmc-total-price">$ {invoiceSubtotal.toFixed(2)}</p>
                  </div>

                  {taxesArrayAll.map((tax, i) => (
                    tax.total.toFixed(2) > 0 ? (
                      <div className="vmc-total-row" key={tax.tax_id || i}>
                        <p>Impuesto {tax.tax}</p>
                        <p className="vmc-total-price">$ {tax.total.toFixed(2)}</p>
                      </div>
                    ) : null
                  ))}

                  <div className="vmc-total-row is-grand">
                    <p>Total</p>
                    <p className="vmc-total-price">
                      <small>$</small>{invoiceTotal.toFixed(2)}
                    </p>
                  </div>
                </div>

                <div className="vmc-actions">
                  <button
                    className="vmc-btn-pay"
                    data-bs-dismiss="modal"
                    onClick={() => (setShowModalPayment(true))}
                    // disabled={shoppingCart.length === 0}
                  >
                    <i className="uil uil-credit-card"></i>
                    Realizar Pago
                  </button>
                  <button
                    className="vmc-btn-cancel"
                    onClick={clearShoppingCart}
                    data-bs-dismiss="modal"
                  >
                    <i className="uil uil-times"></i>
                    Cancelar
                  </button>
                </div>
              </div>
            </footer>

          </div>
        </Modal.Body>
      </Modal>

      <VendingMetPayments showModalPayment={showModalPayment} setShowModalPayment={setShowModalPayment} shoppingCart={shoppingCart} invoiceSubtotal={invoiceSubtotal} invoiceTotal={invoiceTotal} invoiceTotalItbms={invoiceTotalItbms} invoiceTotalDiscount={invoiceTotalDiscount} dataClient={dataClient} setDataClient={setDataClient} setShoppingCart={setShoppingCart} setShowModalShopingCart={setShowModalShopingCart} setEventHandlerShoppingCart={setEventHandlerShoppingCart} setEventHandlerMenu={setEventHandlerMenu} setStatusScreen={setStatusScreen} statusComunicationVending={statusComunicationVending} calculateInvoiceTotals={calculateInvoiceTotals} groups={groups} taxesArrayAll={taxesArrayAll} orderNumber={orderNumber} setOrderNumber={setOrderNumber} payments={payments} setPayments={setPayments} oledScreenPayments={oledScreenPayments} getTemp={getTemp} setAtivityTimer={setAtivityTimer}></VendingMetPayments>

    </>
  )
}

export default VendingModalCart
